// Leaflet's default-marker icon refers to relative image paths that don't
// survive Vite bundling. Re-mapping the URLs to bundler-resolved imports is
// the standard fix. We also pull in the Leaflet + cluster CSS here so it
// only ships when the map page is loaded.
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

import L from 'leaflet'
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png'
import iconUrl from 'leaflet/dist/images/marker-icon.png'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'
import {
  UPCOMING_MARKER_COLOR, UPCOMING_MARKER_STROKE,
  PAST_MARKER_COLOR, PAST_MARKER_STROKE,
} from './mapColors.js'

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({ iconRetinaUrl, iconUrl, shadowUrl })

// #334: past events plot in a different colour from upcoming ones, so a year
// view is readable at a glance rather than a wall of identical blue pins.
//
// Built as divIcons carrying an inline SVG rather than shipping a second set
// of PNGs: the shape is Leaflet's own teardrop, the only thing that varies is
// the fill, and a data-free icon keeps the bundle unchanged. Sizing and anchor
// match L.Icon.Default (25x41, tip at the bottom centre) so a past marker sits
// on exactly the same point as an upcoming one.
const PIN_SVG = (fill, stroke) => `
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="41" viewBox="0 0 25 41" aria-hidden="true">
  <path d="M12.5 0.75C6.0 0.75 0.75 6.0 0.75 12.5c0 8.9 11.75 27.75 11.75 27.75S24.25 21.4 24.25 12.5C24.25 6.0 19.0 0.75 12.5 0.75z"
        fill="${fill}" stroke="${stroke}" stroke-width="1.5"/>
  <circle cx="12.5" cy="12.5" r="4.5" fill="#ffffff"/>
</svg>`

function pinIcon(fill, stroke, className) {
  return L.divIcon({
    className,
    html: PIN_SVG(fill, stroke),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  })
}

export const upcomingIcon = pinIcon(
  UPCOMING_MARKER_COLOR, UPCOMING_MARKER_STROKE, 'next-marker next-marker-upcoming')
export const pastIcon = pinIcon(
  PAST_MARKER_COLOR, PAST_MARKER_STROKE, 'next-marker next-marker-past')
